/**
 * Tenant RPC Definitions
 */

import { Rpc, RpcGroup } from "effect/rpc";
import { Schema } from "effect";
import {
  ListTenantsRequestSchema,
  ListTenantsResponseSchema,
} from "../schemas/tenant/index";
import { ExternalAPIErrorSchema, NotFoundErrorSchema } from "../errors";

export class TenantRpcs extends RpcGroup.make(
  Rpc.make("TenantList", {
    success: ListTenantsResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: ListTenantsRequestSchema,
  })
) {}
